import NotFoundImage from 'assets/images/404';
import { Title } from 'library/styles/text';
import { Container } from './styles';

export default () => (
  <Container>
    <NotFoundImage />
    <Title>Page not found</Title>
  </Container>
);
